export const equationDict = {
  ru: {
    "[E] is missing in [S] part":
      "Отсутствует элемент [E] в [S#] части уравнения",
    "left|part": "левой",
    "right|part": "правой",
    "Equation not specified": "Уравнение не задано",
    "No separating operation":
      "Требуется одна операция, разделяющая левую и правую часть уравнения",
    "No solution": "Не удалось найти решение",
    "Cant balance expression with abstract coefficients":
      "Невозможно балансировать уравнение с абстрактными коэффициентами",
    "Cant balance expression with non-integer coefficients":
      "Невозможно балансировать уравнение с дробными коэффициентами",
    "Cant balance expression with mineral series":
      "Невозможно балансировать неопределенные формулы минералов",
    "Invalid expression": "Неподходящее выражение",
  },
  en: {
    "[E] is missing in [S] part":
      "Element [E] is missing on the [S#] side of the equation.",
    "left|part": "left",
    "right|part": "right",
    "Equation not specified": "The equation is not specified",
    "No separating operation":
      "Requires a single operation, separating the left and right side of the equation",
    "No solution": "Could not find a solution",
    "Cant balance expression with abstract coefficients":
      "Can't balance expression with abstract coefficients",
    "Cant balance expression with non-integer coefficients":
      "Can't balance expression with non-integer coefficients",
    "Cant balance expression with mineral series":
      "Can't balance expression with mineral series",
    "Invalid expression": "Неподходящее выражение",
  },
};
